const NO_LABEL = 'Όχι';
const YES_LABEL = 'Ναι';
const LESS_THAN_ONE_YEAR_LABEL = 'Λιγότερο από ένα';

const jobOptions = [
  { value: 0, label: 'Άλλο' },
  { value: 1, label: 'Άνεργος' },
  { value: 2, label: 'Ένστολος (πλην Αστυνομικών)' },
  { value: 3, label: 'Αστυνομικός' },
  { value: 4, label: 'Δημόσιος Υπάλληλος' },
  { value: 5, label: 'Συνταξιούχος Αστυνομικός' },
  { value: 6, label: 'Συνταξιούχος Δημοσίου' },
];

const coDriverOptions = [
  { label: NO_LABEL, value: false },
  { label: YES_LABEL, value: true },
]

const booleanOptions = [
  { label: YES_LABEL, value: true },
  { label: NO_LABEL, value: false }
];

const freelancerOptions = [...booleanOptions];
const epitideumatiasOptions = [...booleanOptions];
const contactAddressOptions = [...booleanOptions];

const vehicleCategoryOptions = [
  { value: 'car', label: 'Επιβατικό Ι.Χ.' },
  { value: 'truck', label: 'Φορτηγό Ι.Χ.' },
  { value: 'rural', label: 'Αγροτικό Ι.Χ.' },
  { value: 'bike', label: 'Mηχανή' },
  { value: 'taxi', label: 'Ταξί' },
  { value: 'rentalcar', label: 'Ενοικιαζόμενο Ε.Ι.Χ.' },
  { value: 'trailer', label: 'Ρυμούλκα' },
];

const basicVehicleTypeOptions = [
  { value: 0, label: 'Χωρίς' },
  { value: 5, label: 'Ρυμουλκό 2 τροχών' },
]

const vehicleTypeOptions = [
  ...basicVehicleTypeOptions,
  {
    value: 6,
    label: 'Ρυμουλκό 4 τροχών',
  },
  {
    value: 7,
    label: 'Ρυμουλκό 6 τροχών',
  },
  {
    value: 8,
    label: 'Τροχόσπιτο 2 τροχών',
  },
  {
    value: 9,
    label: 'Τροχόσπιτο 4 τροχών',
  },
  {
    value: 10,
    label: 'Τροχόσπιτο 6 τροχών',
  },
  {
    value: 11,
    label: 'Λέμβος ή Τρέιλερ 2 τροχών',
  },
  {
    value: 12,
    label: 'Λέμβος ή Τρέιλερ 4 τροχών',
  },
  {
    value: 13,
    label: 'Λέμβος ή Τρέιλερ 6 τροχών',
  },
];

const heavyOptions = [...booleanOptions];
const onlyDriverOptions = [...booleanOptions];
const immobilizerOptions = [...booleanOptions];

const usedVehicle = [
  { label: 'Καινούργιο', value: false },
  { label: 'Μεταχειρισμένο', value: true },
]

const PersonValue = 4;
const CompanyValue = 3;
const customerTypeOptions = [
  { label: 'Ιδιώτης', value: PersonValue },
  { label: 'Εταιρεία', value: CompanyValue },
]

const fridgeOptions = [...booleanOptions];
const hasHighTurnoverOptions = [...booleanOptions].reverse();

const commonBasicPacketOption = [
  { label: 'Βασικό', value: 0, tooltip: 'Συμπεριλαμβάνει κατ\'ελάχιστο την υποχρεωτική από το νόμο κάλυψη Αστικής Ευθύνης έναντι τρίτων για Σωματικές Βλάβες & Υλικες Ζημιές.'},
]

const carPacketOptions = [
  ...commonBasicPacketOption,
  { label: 'Πυρός/Κλοπής', value: 1, tooltip: 'Επιλογή Value for Money! Με μικρό επιπλέον κόστος, έχεις κάλυψη για κλοπή & φωτιά', sublabel: 'Προτίμησέ το αν δεν έχεις parking ή οδηγείς δημοφιλές μοντέλο μικρού ή μεσαίου κυβισμού'},
  { label: 'Μικτή', value: 2, tooltip: 'Η πιο ολοκληρωμένη κάλυψη. Καλύπτει ΚΑΙ τις ζημιές που θα προκληθούν στο όχημά σου από δική σου υπαιτιότητα', sublabel: 'Προτίμησέ το αν είσαι νέος οδηγός ή οδηγείς όχημα καινούριο ή μεγάλης αξίας!'},
];

const commonExtraPacketOptions = [
  { label: 'Πυρός/Κλοπής', value: 1, tooltip: `Συμπεριλαμβάνει κατ\'ελάχιστο τις καλύψεις: Α.Ε. Σωματικές Βλάβες & Υλικες Ζημιές, Πυρός.`}
]

const bikePacketOptions = [
  ...commonBasicPacketOption,
  ...commonExtraPacketOptions
];

const taxiPacketOptions = [
  ...commonBasicPacketOption,
  { label: 'Πυρός/Κλοπής', value: 1, tooltip: 'Επιλογή Value for Money! Με μικρό επιπλέον κόστος του βασικού, έχεις κάλυψη για κλοπή/φωτιά στα οχήματα. Η κάλυψη κλοπής διατίθεται όπου προβλέπεται. Αξίζει!' },
];

const rentalCarPacketOptions = [
  ...commonBasicPacketOption,
  { label: 'Πυρός/Κλοπής', value: 1, tooltip: 'Επιλογή Value for Money! Με μικρό επιπλέον κόστος του βασικού, έχεις κάλυψη για κλοπή/φωτιά στα οχήματα. Η κάλυψη κλοπής διατίθεται όπου προβλέπεται. Αξίζει!' },
  { label: 'Μικτή', value: 2, tooltip: 'Η πιο ολοκληρωμένη κάλυψη. Καλύπτει ΚΑΙ τις ζημιές που θα προκληθούν στο όχημά σου από δική σου υπαιτιότητα' }
];

const truckRuralPacketOptions = [
  ...commonBasicPacketOption,
  ...commonExtraPacketOptions,
  { label: 'Μικτή', value: 2, tooltip: 'Η πιο ολοκληρωμένη κάλυψη. Καλύπτει ΚΑΙ τις ζημιές που θα προκληθούν στο όχημά σου από δική σου υπαιτιότητα'}
]

const commonDurationOptions = [
  { label: '3 Μήνες', value: 3 },
  { label: '1 Μήνας', value: 1 }
]

const carDurationOptions = [
  { label: '12 Μήνες', value: 12, sublabel: 'έως 47% έκπτωση διάρκειας'},
  { label: '6 Μήνες', value: 6, sublabel: 'έως 25% έκπτωση διάρκειας'},
  ...commonDurationOptions
]

const bikeDurationOptions = [
  { label: '12 Μήνες', value: 12, sublabel: 'έως 40% έκπτωση διάρκειας'},
  { label: '6 Μήνες', value: 6},
  ...commonDurationOptions
]

const truckRuralDurationOptions = [
  { label: '12 Μήνες', value: 12, sublabel: 'έως 15% έκπτωση διάρκειας'},
  { label: '6 Μήνες', value: 6},
  ...commonDurationOptions
]

const taxiDurationOptions = [
  { label: '12 Μήνες', value: 12, sublabel: 'έως 15% έκπτωση διάρκειας'},
  { label: '6 Μήνες', value: 6},
  { label: '3 Μήνες', value: 3 }
]

const rentalCarDurationOptions = [
  { label: '12 Μήνες', value: 12, sublabel: 'έως 15% έκπτωση διάρκειας'},
  { label: '6 Μήνες', value: 6},
  ...commonDurationOptions
]

const coverOptions = [
  {label: 'Οδική Βοήθεια', value: "cc19", tooltip: 'Σε καλύπτει σε περίπτωση ακινητοποίησης του οχήματός σου λόγω βλάβης, σκασμένου ελαστικού, μπαταρίας, έλλειψης καυσίμου ή άλλων απροόπτων.'},
  {label: 'Θραύση Κρυστάλλων', value: "cc06", tooltip: 'Καλύπτει ζημιές από εξωτερική αιτία στα παράθυρα και στο μπρος & πίσω παρμπρίζ. Ανάλογα με την ασφαλιστική εταιρεία, ενδέχεται να έχεις κάλυψη και σε κρυστάλλινες οροφές, αισθητήρες βροχής & στις ενσωματωμένες στα κρύσταλλα προστατευτικές μεμβράνες.'},
  {label: 'Νομική Προστασία', value: "cc10", tooltip: 'Καλύπτει τα έξοδά σου για να διεκδικήσεις νομικά τη νόμιμη αποζημίωσή σου ή μία δικαιότερη αποζημίωση από αυτήν που σου προτείνεται από την ασφαλιστική του ζημιογόνου οχήματος.'},
  {label: 'Προσωπικό Ατύχημα', value: "cc12", tooltip: 'Σε περίπτωση σοβαρού ατυχήματος, η ασφαλιστική σου εταιρεία θα σε βοηθήσει οικονομικά στη μόνιμη ολική ανικανότητα & θα αποζημιώσει τον δικαιούχο σου σε περίπτωση θανάτου. Ανάλογα με την ασφαλιστική εταιρεία, ενδέχεται να έχεις οικονομική βοήθεια και σε μόνιμη μερική ανικανότητα, ιατροφαρμακευτικά έξοδα & νοσοκομειακή περίθαλψη.'},
]

const hasCompleteValidBirthDate = (birthDate) => {
  const day = `${birthDate?.day ?? ''}`;
  const month = `${birthDate?.month ?? ''}`;
  const year = `${birthDate?.year ?? ''}`;

  if (!day || !month || day.length > 2 || month.length > 2 || year.length !== 4) {
    return false;
  }

  const parsedDay = Number.parseInt(day, 10);
  const parsedMonth = Number.parseInt(month, 10);
  const parsedYear = Number.parseInt(year, 10);

  if ([parsedDay, parsedMonth, parsedYear].some(Number.isNaN)) {
    return false;
  }

  const date = new Date(parsedYear, parsedMonth - 1, parsedDay);

  return (
    date.getFullYear() === parsedYear &&
    date.getMonth() === parsedMonth - 1 &&
    date.getDate() === parsedDay
  );
};

const getLicenseYearsOptions = (birthDate) => {
  if (!hasCompleteValidBirthDate(birthDate)) {
    return [];
  }

  const day = Number.parseInt(birthDate.day, 10);
  const month = Number.parseInt(birthDate.month, 10);
  const year = Number.parseInt(birthDate.year, 10);

  const today = new Date();
  const firstLicenseDate = new Date(year + 17, month - 1, day);

  if (firstLicenseDate > today) {
    return [];
  }

  let yearsOfLicense = today.getFullYear() - firstLicenseDate.getFullYear();

  const hasNotCompletedCurrentYear =
    today.getMonth() < firstLicenseDate.getMonth() ||
    (today.getMonth() === firstLicenseDate.getMonth() &&
      today.getDate() < firstLicenseDate.getDate());

  if (hasNotCompletedCurrentYear) {
    yearsOfLicense -= 1;
  }

  const normalizedYears = Math.max(0, yearsOfLicense);

  const options = Array.from({ length: normalizedYears }, (_, index) => {
    const value = normalizedYears - index;

    return {
      value,
      label: `Από ${value} έως ${value + 1} έτη`,
    };
  });

  return [
    ...options,
    { value: 0, label: LESS_THAN_ONE_YEAR_LABEL },
  ];
};

const getRentalCarDurationOptions = (selectedPacketOption) => {
  if (selectedPacketOption !== 0) {
    return rentalCarDurationOptions.filter(option => option.value !== 1);
  }
  return rentalCarDurationOptions;
};

const colorOptions = [
  { label: "ΛΕΥΚΟ", value: "1" },
  { label: "ΜΑΥΡΟ", value: "2" },
  { label: "ΜΠΟΡΝΤΩ", value: "3" },
  { label: "ΚΟΚΚΙΝΟ", value: "4" },
  { label: "ΓΚΡΙ", value: "5" },
  { label: "ΜΠΛΕ", value: "6" },
  { label: "ΠΟΡΤΟΚΑΛΙ", value: "7" },
  { label: "ΠΡΑΣΙΝΟ", value: "8" },
  { label: "ΚΙΤΡΙΝΟ", value: "9" },
  { label: "ΚΑΦΕ", value: "10" },
  { label: "ΑΣΗΜΙ", value: "11" },
  { label: "ΒΥΣΣΙΝΙ", value: "12" },
  { label: "MOΛYBI", value: "13" },
  { label: "ΜΕΛΙΤΖΑΝΙ", value: "14" },
  { label: "ΜΩΒ", value: "15" },
  { label: "ΜΠΕΖ", value: "16" },
  { label: "ΧΡΥΣΑΦΙ", value: "17" },
  { label: "ΚΕΡΑΜΙΔΙ", value: "18" },
  { label: "ΡΟΖ", value: "19" },
  { label: "ΑΝΘΡΑΚΙ", value: "20" },
  { label: "ΓΡΑΦΙΤΗΣ", value: "21" },
  { label: "ΠΕΤΡΟΛ", value: "22" },
  { label: "ΘΑΛΑΣΣΙ", value: "23" },
  { label: "ΣΑΜΠΑΝΙ", value: "24" },
  { label: "ΛΑΔΙ", value: "25" },
  { label: "ΚΥΠΑΡΙΣΣΙ", value: "26" },
  { label: "ΓΑΛΑΖΙΟ", value: "27" },
  { label: "ΠΛΑΤΙΝΑ", value: "28" },
  { label: "ΕΚΡΟΥ", value: "29" },
  { label: "ΦΥΣΤΙΚΙ", value: "30" },
  { label: "ΓΚΡΕΝΑ", value: "31" },
  { label: "ΚΟΚΚΑΛΙ", value: "32" },
  { label: "ΚΡΕΜ", value: "33" },
  { label: "ΛΑΧΑΝΙ", value: "34" },
  { label: "ΜΟΛΥΒΙ", value: "35" },
  { label: "ΜΟΥΣΤΑΡΔΙ", value: "36" }
];

const EUROPA_COLOR_LABELS = ["ΛΕΥΚΟ", "ΜΑΥΡΟ", "ΚΟΚΚΙΝΟ", "ΓΚΡΙ", "ΜΠΛΕ", "ΠΟΡΤΟΚΑΛΙ", "ΠΡΑΣΙΝΟ", "ΚΙΤΡΙΝΟ", "ΚΑΦΕ", "ΑΣΗΜΙ", "ΜΩΒ", "ΘΑΛΑΣΣΙ"];
const europaColorOptions = colorOptions.filter(({ label }) => EUROPA_COLOR_LABELS.includes(label));

const INTERAMERICAN_EXCLUDED_COLOR_LABELS = ["ΘΑΛΑΣΣΙ", "ΣΑΜΠΑΝΙ", "ΠΛΑΤΙΝΑ", "ΕΚΡΟΥ"];
const interamericanColorOptions = colorOptions.filter(({ label }) => !INTERAMERICAN_EXCLUDED_COLOR_LABELS.includes(label));

const GROUPAMA_EXCLUDED_COLOR_LABELS = ["ΜΕΛΙΤΖΑΝΙ", "ΣΑΜΠΑΝΙ", "ΕΚΡΟΥ"];
const groupamaColorOptions = colorOptions.filter(({ label }) => !GROUPAMA_EXCLUDED_COLOR_LABELS.includes(label));

const countryOptions = [
  { label: "Ελλάδα", code: 1, value: "Ελλάδα" },
  { label: "Afghanistan", code: 2, value: "Afghanistan" },
  { label: "Albania", code: 3, value: "Albania" },
  { label: "Algeria", code: 4, value: "Algeria" },
  { label: "Argentina", code: 5, value: "Argentina" },
  { label: "Armenia", code: 6, value: "Armenia" },
  { label: "Australia", code: 7, value: "Australia" },
  { label: "Austria", code: 8, value: "Austria" },
  { label: "Bahrain", code: 9, value: "Bahrain" },
  { label: "Bangladesh", code: 10, value: "Bangladesh" },
  { label: "Belarus", code: 11, value: "Belarus" },
  { label: "Belgium", code: 12, value: "Belgium" },
  { label: "Bolivia", code: 13, value: "Bolivia" },
  { label: "Bosnia and Herzegovina", code: 14, value: "Bosnia and Herzegovina" },
  { label: "Brazil", code: 15, value: "Brazil" },
  { label: "Brunei", code: 16, value: "Brunei" },
  { label: "Bulgaria", code: 17, value: "Bulgaria" },
  { label: "Cameroon", code: 18, value: "Cameroon" },
  { label: "Canada", code: 19, value: "Canada" },
  { label: "Chile", code: 20, value: "Chile" },
  { label: "China", code: 21, value: "China" },
  { label: "Colombia", code: 22, value: "Colombia" },
  { label: "Costa Rica", code: 23, value: "Costa Rica" },
  { label: "Croatia", code: 24, value: "Croatia" },
  { label: "Cuba", code: 25, value: "Cuba" },
  { label: "Cyprus", code: 26, value: "Cyprus" },
  { label: "Czech Republic", code: 27, value: "Czech Republic" },
  { label: "Denmark", code: 28, value: "Denmark" },
  { label: "Ecuador", code: 29, value: "Ecuador" },
  { label: "Egypt", code: 30, value: "Egypt" },
  { label: "Estonia", code: 31, value: "Estonia" },
  { label: "Ethiopia", code: 32, value: "Ethiopia" },
  { label: "F.Y.R.O.M.", code: 33, value: "F.Y.R.O.M." },
  { label: "Finland", code: 34, value: "Finland" },
  { label: "France", code: 35, value: "France" },
  { label: "Georgia", code: 36, value: "Georgia" },
  { label: "Germany", code: 37, value: "Germany" },
  { label: "Ghana", code: 38, value: "Ghana" },
  { label: "Hungary", code: 39, value: "Hungary" },
  { label: "Iceland", code: 40, value: "Iceland" },
  { label: "India", code: 41, value: "India" },
  { label: "Indonesia", code: 42, value: "Indonesia" },
  { label: "Iran", code: 43, value: "Iran" },
  { label: "Iraq", code: 44, value: "Iraq" },
  { label: "Ireland", code: 45, value: "Ireland" },
  { label: "Israel", code: 46, value: "Israel" },
  { label: "Italy", code: 47, value: "Italy" },
  { label: "Jamaica", code: 48, value: "Jamaica" },
  { label: "Japan", code: 49, value: "Japan" },
  { label: "Jordan", code: 50, value: "Jordan" },
  { label: "Kazakhstan", code: 51, value: "Kazakhstan" },
  { label: "Kenya", code: 52, value: "Kenya" },
  { label: "Korea, North", code: 53, value: "Korea, North" },
  { label: "Korea, South", code: 54, value: "Korea, South" },
  { label: "Kosovo", code: 55, value: "Kosovo" },
  { label: "Kuwait", code: 56, value: "Kuwait" },
  { label: "Latvia", code: 57, value: "Latvia" },
  { label: "Lebanon", code: 58, value: "Lebanon" },
  { label: "Liberia", code: 59, value: "Liberia" },
  { label: "Libya", code: 60, value: "Libya" },
  { label: "Liechtenstein", code: 61, value: "Liechtenstein" },
  { label: "Lithuania", code: 62, value: "Lithuania" },
  { label: "Luxembourg", code: 63, value: "Luxembourg" },
  { label: "Malaysia", code: 64, value: "Malaysia" },
  { label: "Maldives", code: 65, value: "Maldives" },
  { label: "Mali", code: 66, value: "Mali" },
  { label: "Malta", code: 67, value: "Malta" },
  { label: "Mexico", code: 68, value: "Mexico" },
  { label: "Moldova", code: 69, value: "Moldova" },
  { label: "Monaco", code: 70, value: "Monaco" },
  { label: "Mongolia", code: 71, value: "Mongolia" },
  { label: "Montenegro", code: 72, value: "Montenegro" },
  { label: "Morocco", code: 73, value: "Morocco" },
  { label: "Mozambique", code: 74, value: "Mozambique" },
  { label: "Namibia", code: 75, value: "Namibia" },
  { label: "Nepal", code: 76, value: "Nepal" },
  { label: "Netherlands", code: 77, value: "Netherlands" },
  { label: "New Zealand", code: 78, value: "New Zealand" },
  { label: "Nicaragua", code: 79, value: "Nicaragua" },
  { label: "Niger", code: 80, value: "Niger" },
  { label: "Nigeria", code: 81, value: "Nigeria" },
  { label: "Norway", code: 82, value: "Norway" },
  { label: "Oman", code: 83, value: "Oman" },
  { label: "Pakistan", code: 84, value: "Pakistan" },
  { label: "Panama", code: 85, value: "Panama" },
  { label: "Paraguay", code: 86, value: "Paraguay" },
  { label: "Peru", code: 87, value: "Peru" },
  { label: "Philippines", code: 88, value: "Philippines" },
  { label: "Poland", code: 89, value: "Poland" },
  { label: "Portugal", code: 90, value: "Portugal" },
  { label: "Qatar", code: 91, value: "Qatar" },
  { label: "Romania", code: 92, value: "Romania" },
  { label: "Russia", code: 93, value: "Russia" },
  { label: "Serbia", code: 94, value: "Serbia" },
  { label: "Singapore", code: 95, value: "Singapore" },
  { label: "Slovakia", code: 96, value: "Slovakia" },
  { label: "Slovenia", code: 97, value: "Slovenia" },
  { label: "South Africa", code: 98, value: "South Africa" },
  { label: "Spain", code: 99, value: "Spain" },
  { label: "Sri Lanka", code: 100, value: "Sri Lanka" },
  { label: "Sudan", code: 101, value: "Sudan" },
  { label: "Sweden", code: 102, value: "Sweden" },
  { label: "Switzerland", code: 103, value: "Switzerland" },
  { label: "Syria", code: 104, value: "Syria" },
  { label: "Taiwan", code: 105, value: "Taiwan" },
  { label: "Thailand", code: 106, value: "Thailand" },
  { label: "Trinidad and Tobago", code: 107, value: "Trinidad and Tobago" },
  { label: "Tunisia", code: 108, value: "Tunisia" },
  { label: "Turkey", code: 109, value: "Turkey" },
  { label: "Ukraine", code: 110, value: "Ukraine" },
  { label: "United Arab Emirates", code: 111, value: "United Arab Emirates" },
  { label: "United Kingdom", code: 112, value: "United Kingdom" },
  { label: "United States", code: 113, value: "United States" },
  { label: "Uruguay", code: 114, value: "Uruguay" },
  { label: "Uzbekistan", code: 115, value: "Uzbekistan" },
  { label: "Venezuela", code: 116, value: "Venezuela" },
  { label: "Vietnam", code: 117, value: "Vietnam" },
  { label: "", code: -9999, value: "" },
];

const nationalityOptions = [
  { label: "Ελληνική", code: 67, value: "Ελληνική" },
  { label: "Afghan", code: 0, value: "Afghan" },
  { label: "Albanian", code: 1, value: "Albanian" },
  { label: "Algerian", code: 2, value: "Algerian" },
  { label: "Andorran", code: 4, value: "Andorran" },
  { label: "Angolan", code: 5, value: "Angolan" },
  { label: "Antiguans", code: 6, value: "Antiguans" },
  { label: "Argentinean", code: 7, value: "Argentinean" },
  { label: "Armenian", code: 8, value: "Armenian" },
  { label: "Australian", code: 9, value: "Australian" },
  { label: "Austrian", code: 10, value: "Austrian" },
  { label: "Azerbaijani", code: 11, value: "Azerbaijani" },
  { label: "Bahamian", code: 12, value: "Bahamian" },
  { label: "Bahraini", code: 13, value: "Bahraini" },
  { label: "Bangladeshi", code: 14, value: "Bangladeshi" },
  { label: "Barbadian", code: 15, value: "Barbadian" },
  { label: "Belarusian", code: 16, value: "Belarusian" },
  { label: "Belgian", code: 17, value: "Belgian" },
  { label: "Belizean", code: 18, value: "Belizean" },
  { label: "Beninese", code: 19, value: "Beninese" },
  { label: "Bhutanese", code: 20, value: "Bhutanese" },
  { label: "Bolivian", code: 21, value: "Bolivian" },
  { label: "Bosnian/Herzegovinian", code: 22, value: "Bosnian/Herzegovinian" },
  { label: "Motswana", code: 120, value: "Motswana" },
  { label: "Brazilian", code: 23, value: "Brazilian" },
  { label: "Bruneian", code: 25, value: "Bruneian" },
  { label: "Bulgarian", code: 26, value: "Bulgarian" },
  { label: "Burkinabe", code: 27, value: "Burkinabe" },
  { label: "Burundian", code: 28, value: "Burundian" },
  { label: "Cambodian", code: 29, value: "Cambodian" },
  { label: "Cameroonian", code: 30, value: "Cameroonian" },
  { label: "Canadian", code: 31, value: "Canadian" },
  { label: "Cape Verdian", code: 32, value: "Cape Verdian" },
  { label: "Central African", code: 33, value: "Central African" },
  { label: "Chadian", code: 34, value: "Chadian" },
  { label: "Chilean", code: 35, value: "Chilean" },
  { label: "Chinese", code: 36, value: "Chinese" },
  { label: "Colombian", code: 37, value: "Colombian" },
  { label: "Comoran", code: 38, value: "Comoran" },
  { label: "Congolese", code: 39, value: "Congolese" },
  { label: "Costa Rican", code: 40, value: "Costa Rican" },
  { label: "Ivorian", code: 85, value: "Ivorian" },
  { label: "Croatian", code: 41, value: "Croatian" },
  { label: "Cuban", code: 42, value: "Cuban" },
  { label: "Cypriot", code: 43, value: "Cypriot" },
  { label: "Czech", code: 44, value: "Czech" },
  { label: "Danish", code: 45, value: "Danish" },
  { label: "Djibouti", code: 46, value: "Djibouti" },
  { label: "Dominican", code: 47, value: "Dominican" },
  { label: "East Timorese", code: 49, value: "East Timorese" },
  { label: "Ecuadorean", code: 50, value: "Ecuadorean" },
  { label: "Egyptian", code: 51, value: "Egyptian" },
  { label: "Salvadoran", code: 147, value: "Salvadoran" },
  { label: "Equatorial Guinean", code: 53, value: "Equatorial Guinean" },
  { label: "Eritrean", code: 54, value: "Eritrean" },
  { label: "Estonian", code: 55, value: "Estonian" },
  { label: "Ethiopian", code: 56, value: "Ethiopian" },
  { label: "Fijian", code: 58, value: "Fijian" },
  { label: "Finnish", code: 60, value: "Finnish" },
  { label: "French", code: 61, value: "French" },
  { label: "Gabonese", code: 62, value: "Gabonese" },
  { label: "Gambian", code: 63, value: "Gambian" },
  { label: "Georgian", code: 64, value: "Georgian" },
  { label: "German", code: 65, value: "German" },
  { label: "Ghanaian", code: 66, value: "Ghanaian" },
  { label: "Grenadian", code: 68, value: "Grenadian" },
  { label: "Guatemalan", code: 69, value: "Guatemalan" },
  { label: "Guinean", code: 71, value: "Guinean" },
  { label: "Guinea-Bissauan", code: 70, value: "Guinea-Bissauan" },
  { label: "Guyanese", code: 72, value: "Guyanese" },
  { label: "Haitian", code: 73, value: "Haitian" },
  { label: "Honduran", code: 74, value: "Honduran" },
  { label: "Hungarian", code: 75, value: "Hungarian" },
  { label: "Icelander", code: 77, value: "Icelander" },
  { label: "Indian", code: 78, value: "Indian" },
  { label: "Indonesian", code: 79, value: "Indonesian" },
  { label: "Iranian", code: 80, value: "Iranian" },
  { label: "Iraqi", code: 81, value: "Iraqi" },
  { label: "Irish", code: 82, value: "Irish" },
  { label: "Israeli", code: 83, value: "Israeli" },
  { label: "Italian", code: 84, value: "Italian" },
  { label: "Jamaican", code: 86, value: "Jamaican" },
  { label: "Japanese", code: 87, value: "Japanese" },
  { label: "Jordanian", code: 88, value: "Jordanian" },
  { label: "Kazakhstani", code: 89, value: "Kazakhstani" },
  { label: "Kenyan", code: 90, value: "Kenyan" },
  { label: "I-Kiribati", code: 76, value: "I-Kiribati" },
  { label: "North Korean", code: 131, value: "North Korean" },
  { label: "South Korean", code: 162, value: "South Korean" },
  { label: "Kosovar", code: 92, value: "Kosovar" },
  { label: "Kuwaiti", code: 93, value: "Kuwaiti" },
  { label: "Kyrgyz", code: 94, value: "Kyrgyz" },
  { label: "Laotian", code: 95, value: "Laotian" },
  { label: "Latvian", code: 96, value: "Latvian" },
  { label: "Lebanese", code: 97, value: "Lebanese" },
  { label: "Mosotho", code: 119, value: "Mosotho" },
  { label: "Liberian", code: 98, value: "Liberian" },
  { label: "Libyan", code: 99, value: "Libyan" },
  { label: "Liechtensteiner", code: 100, value: "Liechtensteiner" },
  { label: "Lithuanian", code: 101, value: "Lithuanian" },
  { label: "Luxembourger", code: 102, value: "Luxembourger" },
  { label: "F.Y.R.O.M", code: 57, value: "F.Y.R.O.M" },
  { label: "Malagasy", code: 103, value: "Malagasy" },
  { label: "Malawian", code: 104, value: "Malawian" },
  { label: "Malaysian", code: 105, value: "Malaysian" },
  { label: "Maldivan", code: 106, value: "Maldivan" },
  { label: "Malian", code: 107, value: "Malian" },
  { label: "Maltese", code: 108, value: "Maltese" },
  { label: "Marshallese", code: 109, value: "Marshallese" },
  { label: "Mauritanian", code: 110, value: "Mauritanian" },
  { label: "Mauritian", code: 111, value: "Mauritian" },
  { label: "Mexican", code: 112, value: "Mexican" },
  { label: "Micronesian", code: 113, value: "Micronesian" },
  { label: "Moldovan", code: 114, value: "Moldovan" },
  { label: "Monegasque", code: 115, value: "Monegasque" },
  { label: "Mongolian", code: 116, value: "Mongolian" },
  { label: "Montenegrin", code: 117, value: "Montenegrin" },
  { label: "Moroccan", code: 118, value: "Moroccan" },
  { label: "Mozambican", code: 121, value: "Mozambican" },
  { label: "Myanmarese", code: 122, value: "Myanmarese" },
  { label: "Namibian", code: 123, value: "Namibian" },
  { label: "Nauruan", code: 124, value: "Nauruan" },
  { label: "Nepalese", code: 125, value: "Nepalese" },
  { label: "Dutch", code: 48, value: "Dutch" },
  { label: "New Zealander", code: 126, value: "New Zealander" },
  { label: "Nicaraguan", code: 128, value: "Nicaraguan" },
  { label: "Nigerien", code: 130, value: "Nigerien" },
  { label: "Nigerian", code: 129, value: "Nigerian" },
  { label: "Norwegian", code: 132, value: "Norwegian" },
  { label: "Omani", code: 133, value: "Omani" },
  { label: "Pakistani", code: 134, value: "Pakistani" },
  { label: "Palauan", code: 135, value: "Palauan" },
  { label: "Panamanian", code: 136, value: "Panamanian" },
  { label: "Papua New Guinean", code: 137, value: "Papua New Guinean" },
  { label: "Paraguayan", code: 138, value: "Paraguayan" },
  { label: "Peruvian", code: 130, value: "Peruvian" },
  { label: "Filipino", code: 59, value: "Filipino" },
  { label: "Polish", code: 140, value: "Polish" },
  { label: "Portuguese", code: 141, value: "Portuguese" },
  { label: "Qatari", code: 142, value: "Qatari" },
  { label: "Romanian", code: 143, value: "Romanian" },
  { label: "Russian", code: 144, value: "Russian" },
  { label: "Rwandan", code: 145, value: "Rwandan" },
  { label: "Kittian and Nevisian", code: 91, value: "Kittian and Nevisian" },
  { label: "Saint Lucian", code: 146, value: "Saint Lucian" },
  { label: "Samoan", code: 148, value: "Samoan" },
  { label: "San Marinese", code: 149, value: "San Marinese" },
  { label: "Sao Tomean", code: 150, value: "Sao Tomean" },
  { label: "Saudi Arabian", code: 151, value: "Saudi Arabian" },
  { label: "Senegalese", code: 152, value: "Senegalese" },
  { label: "Serbian", code: 153, value: "Serbian" },
  { label: "Seychellois", code: 154, value: "Seychellois" },
  { label: "Sierra Leonean", code: 155, value: "Sierra Leonean" },
  { label: "Singaporean", code: 156, value: "Singaporean" },
  { label: "Slovak", code: 157, value: "Slovak" },
  { label: "Slovenian", code: 158, value: "Slovenian" },
  { label: "Solomon Islander", code: 159, value: "Solomon Islander" },
  { label: "Somali", code: 160, value: "Somali" },
  { label: "South African", code: 161, value: "South African" },
  { label: "Spanish", code: 163, value: "Spanish" },
  { label: "Sri Lankan", code: 164, value: "Sri Lankan" },
  { label: "Sudanese", code: 165, value: "Sudanese" },
  { label: "Surinamer", code: 166, value: "Surinamer" },
  { label: "Swazi", code: 167, value: "Swazi" },
  { label: "Swedish", code: 168, value: "Swedish" },
  { label: "Swiss", code: 169, value: "Swiss" },
  { label: "Syrian", code: 170, value: "Syrian" },
  { label: "Taiwanese", code: 171, value: "Taiwanese" },
  { label: "Tajik", code: 172, value: "Tajik" },
  { label: "Tanzanian", code: 173, value: "Tanzanian" },
  { label: "Thai", code: 174, value: "Thai" },
  { label: "Togolese", code: 175, value: "Togolese" },
  { label: "Tongan", code: 176, value: "Tongan" },
  { label: "Trinidadian/Tobagonian", code: 177, value: "Trinidadian/Tobagonian" },
  { label: "Tunisian", code: 178, value: "Tunisian" },
  { label: "Turkish", code: 179, value: "Turkish" },
  { label: "Turkmen", code: 180, value: "Turkmen" },
  { label: "Tuvaluan", code: 181, value: "Tuvaluan" },
  { label: "Ugandan", code: 182, value: "Ugandan" },
  { label: "Ukrainian", code: 183, value: "Ukrainian" },
  { label: "Emirian", code: 52, value: "Emirian" },
  { label: "British", code: 24, value: "British" },
  { label: "American", code: 3, value: "American" },
  { label: "Uruguayan", code: 184, value: "Uruguayan" },
  { label: "Uzbekistani", code: 185, value: "Uzbekistani" },
  { label: "Ni-Vanuatu", code: 127, value: "Ni-Vanuatu" },
  { label: "Vatican", code: 186, value: "Vatican" },
  { label: "Venezuelan", code: 187, value: "Venezuelan" },
  { label: "Vietnamese", code: 188, value: "Vietnamese" },
  { label: "Yemenite", code: 189, value: "Yemenite" },
  { label: "Zambian", code: 190, value: "Zambian" },
  { label: "Zimbabwean", code: 191, value: "Zimbabwean" },
];

const vehicleCatOptions = [
  { label: "Ερασιτεχνικό", value: 1 },
  { label: "Επαγγελματικό", value: 2 },
  { label: "Εκτός ΕΕ", value: 3 },
]

const licenseCategoryOptions = [
  { label: "Ελληνικό", value: 1 },
  { label: "Διεθνές Ε.Ε.", value: 2 },
  { label: "Άλλο", value: 3 }
];

const vehicleFuelOptions = [
  { label: "Βενζίνη", value: 1 },
  { label: "Πετρέλαιο", value: 2 },
  { label: "Υγραέριο", value: 3 },
]

const companyTypesOptions = [
  { label: "Ανώνυμη Εταιρεία", value: 'ΑΕ' },
  { label: "Εταιρεία Περιορισμένης Ευθύνης", value: "ΕΠΕ" },
  { label: "Ετερόρρυθμη Εταιρεία", value: "ΕΕ" },
  { label: "Ομόρρυθμη Εταιρεία", value: "ΟΕ" },
  { label: "Ατομική Επιχείρηση", value: "ΑΟ" },
]

export {
  basicVehicleTypeOptions, bikeDurationOptions, bikePacketOptions, carDurationOptions, carPacketOptions, coDriverOptions, colorOptions, companyTypesOptions, CompanyValue, contactAddressOptions, countryOptions, coverOptions,
  customerTypeOptions, epitideumatiasOptions, europaColorOptions, freelancerOptions, fridgeOptions, getLicenseYearsOptions, getRentalCarDurationOptions, groupamaColorOptions, hasHighTurnoverOptions, heavyOptions, immobilizerOptions, interamericanColorOptions, jobOptions, LESS_THAN_ONE_YEAR_LABEL, licenseCategoryOptions, nationalityOptions, NO_LABEL, onlyDriverOptions, PersonValue, rentalCarDurationOptions, rentalCarPacketOptions, taxiDurationOptions, taxiPacketOptions, truckRuralDurationOptions, truckRuralPacketOptions, usedVehicle,
  vehicleCategoryOptions, vehicleCatOptions, vehicleFuelOptions, vehicleTypeOptions, YES_LABEL
};

